module.exports = __webpack_public_path__ + "media/images/otter-new-logo-918cb41e.svg";